// The donor theme's type scale as class strings — `mui-typography.tsx`'s, and
// here rather than inside it for the element that is a variant but cannot be
// a `MuiTypography`: the details page's description, which is `body2` over
// markup `HtmlBox` renders.
//
// The numbers are the donor theme's (`react-ui/src/theme/theme.ts`) over MUI
// 9.2's defaults (`createTypography.mjs`); `mui-typography.tsx` carries the
// reasoning. Literal per variant because Tailwind v4 scans source text: a
// class assembled by interpolation generates no CSS.

export const MUI_TYPOGRAPHY_VARIANTS = {
  /** 3rem / 300 / 1.18, −1.5px. */
  h1: "text-[3rem] leading-[1.18] font-light tracking-[-1.5px]",
  /** 2rem / 400 / 1.25, −0.5px. */
  h2: "text-[2rem] leading-[1.25] font-normal tracking-[-0.5px]",
  /** 1.5rem / 400 / 1.36. */
  h3: "text-[1.5rem] leading-[1.36] font-normal",
  /** 1.25rem / 500 / 1.4, 0.25px. */
  h4: "text-[1.25rem] leading-[1.4] font-medium tracking-[0.25px]",
  /** 1.125rem / 500 / 1.36. */
  h5: "text-[1.125rem] leading-[1.36] font-medium",
  /** 1rem / 500 / 1.64. */
  h6: "text-[1rem] leading-[1.64] font-medium",
  /** 1rem / 500 / 1.5. */
  subtitle1: "text-[1rem] leading-[1.5] font-medium",
  /** 0.875rem / 500 / 1.43. */
  subtitle2: "text-[0.875rem] leading-[1.43] font-medium",
  /** 1rem / 400 / 1.5. */
  body1: "text-[1rem] leading-[1.5] font-normal",
  /** 0.875rem / 400 / 1.43. */
  body2: "text-[0.875rem] leading-[1.43] font-normal",
  /** 0.75rem / 400 / 1.66 — the theme sets the size, MUI the rest. */
  caption: "text-[0.75rem] leading-[1.66] font-normal",
  /** 0.75rem / 400 / 2.66, uppercase — MUI's own, untouched by the theme. */
  overline: "text-[0.75rem] leading-[2.66] font-normal uppercase",
} as const;

export type MuiTypographyVariant = keyof typeof MUI_TYPOGRAPHY_VARIANTS;
